import React, { useState } from "react";
import { Box, Text, Flex, Modal, useDisclosure, ModalOverlay, ModalContent, Skeleton, VStack } from "@chakra-ui/react";
import CustomButton from "../custom/Button";
import { Image } from "@chakra-ui/react";
import noProfile from '../../assets/imgs/no_profile.png'

export const UserSkeleton = () => {
  return (
    <React.Fragment>
      <Box py='10px' px='15px' w='100%'>
        <Flex justifyContent='space-between'>
          <Flex gap={4} alignItems='center'>
            <Box h='45px' width='45px'>
              <Skeleton
                borderRadius='100%'
                width='45px' h='45px'
              />
            </Box>

            <Box w='100%'>
              <Box>
                <Skeleton h='10px' w='150px' />
              </Box>

              <Box mt={2}>
                <Skeleton h='10px' w='250px' />
              </Box>
            </Box>
          </Flex>

          <Box display={['none', 'none', 'block']}>
            <Box w='100%'>
              <Flex justifyContent='right'>
                <Skeleton h='10px' w='100px' />
              </Flex>

              <Flex justifyContent='right' mt={2}>
                <Skeleton h='10px' w='150px' />
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Box>
    </React.Fragment>
  )
}

const User = ({ user }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => setIsHovering(true)
  const handleMouseLeave = () => setIsHovering(false)

  const buttonStyles = {
    width: '100%', 
    textAlign: 'left', 
    backgroundColor: isHovering ? '#f2f2f2' : 'white',
    borderRadius: '10px',
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingTop: '10px',
    paddingBottom: '10px',
    transition: 'background-color 100ms ease-in',
    borderBottom: '1px solid #286090'
  }

  return (
    <React.Fragment>
      <CustomButton
        onClick={onOpen}
        style={buttonStyles}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Flex justifyContent='space-between'>
          <Flex gap={4} alignItems='center'>
            <Box width='45px' height='45px'>
              <Image
                src={user?.avatar?.url ? 
                  user?.avatar?.url : 
                  noProfile
                }
                borderRadius='100%'
                width='45px'
                height='45px'
              />
            </Box>

            <Box
              color='gray.500'
              fontWeight='semibold'
            >
              <Text>{user?.firstName} {user?.lastName}</Text>

              <Text
                textOverflow='ellipsis'
                whiteSpace='nowrap'
                overflow='hidden'
              >
                {user.email}
              </Text>
            </Box>
          </Flex>

          <Box display={['none', 'none', 'block']} textAlign='right'>
            <Text
              color={user.verified ? "#37A75B" : 'red.500'} fontWeight='semibold'
            >
              {user.verified ? 'Verified' : 'Not verified'}
            </Text>

            <Text
              color='gray.500' fontWeight='semibold'
            >
              {user.orders.length ? user.orders.length : '0'} (orders)
            </Text>
          </Box>
        </Flex>
      </CustomButton>

      <Modal size='lg' isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <Box pb={8} pt={12} px={5}>
            <Flex 
              justifyContent='center' 
              borderBottom='1px' 
              borderColor='#286090' 
              pb='5'
            >
              <Box width='60px' height='60px'>
                <Image
                  src={user?.avatar?.url ?
                    user?.avatar?.url :
                    noProfile
                  }
                  borderRadius='100%'
                  width='60px'
                  height='60px'
                />
              </Box>
            </Flex>

            <VStack mt='15px' w='100%' spacing='4'>
              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  First name:
                </Text>

                <Text
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.firstName}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Last name:
                </Text>

                <Text
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.lastName}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Email address:
                </Text>

                <Text
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.email}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Status:
                </Text>

                <Text
                  textAlign='right'
                  fontSize='md'
                  color={user.verified ? "#37A75B" : 'red.500'}
                  fontWeight='semibold'
                >
                  {user.verified ? 'Verified' : 'Not verified'}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Phone number:
                </Text>

                <Text
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.phone_number}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Shipping address:
                </Text>

                <Text
                  textAlign='right'
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.shipping_address}
                </Text>
              </Flex>

              <Flex w='100%' justifyContent='space-between'>
                <Text
                  fontSize='md'
                  color='#286090'
                  fontWeight='semibold'
                >
                  Orders:
                </Text>

                <Text
                  textAlign='right'
                  fontSize='md'
                  color='gray.500'
                  fontWeight='semibold'
                >
                  {user.orders.length ? user.orders.length : '0'} (orders)
                </Text>
              </Flex>
            </VStack>
          </Box>
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

export default User